<template>
	<div class="Authority">
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div style="margin-right: 20px;">
				<CommonBtngroup ref="btngroup" :qhide="false" @showclick="showclick" @hide="hide" @select="select"
					@reset="reset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">

			<div style="display: flex;">
				<div style="">
					<el-dropdown @command="handleDrop">
						<div class="drop-down-link">
							批量<i class="el-icon-arrow-down el-icon--right"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="a">打印</el-dropdown-item>
							<el-dropdown-item command="b">下载</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div style="margin-left: 10px;">
					<CommonbtnUpLoad v-if="qx.add" backgroundColor="#F9FAFC" title="批量生成" fontSize="14px"
						@getFile="BatchGeneration" :src="require('@/assets/channel/generation.png')">
					</CommonbtnUpLoad>
				</div>
				<div style="">
					<Commonbtn backgroundColor="#F9FAFC" title="导出" fontSize="14px" @btnclick="ExportAuthoriy"
						:src="require('@/assets/channel/export.png')">
					</Commonbtn>
				</div>
				<!-- <div style="">
          <Commonbtn backgroundColor="#F9FAFC" title="批量打印" fontSize="14px" @btnclick="PrintAll" :src="require('@/assets/channel/Print.png')">
          </Commonbtn>
        </div> -->
				<!-- <div style="">
          <Commonbtn backgroundColor="#F9FAFC" title="批量下载" fontSize="14px" @btnclick="DownloadAll" :src="require('@/assets/channel/all-download.png')">
          </Commonbtn>
        </div> -->
				<div style="" v-if="false">
					<!--  v-if="qx.update" -->
					<Commonbtn backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
						:src="require('@/assets/icon/icon-update.png')">
					</Commonbtn>
				</div>
				<div style="" v-if="false">
					<Commonbtn backgroundColor="#F9FAFC" v-if="qx.enabled" title="审核" fontSize="14px"
						@btnclick="AuthorityVerify" :src="require('@/assets/icon/shen.png')">
					</Commonbtn>
				</div>
				<div style="">
					<Commonbtn backgroundColor="#F9FAFC" v-if="qx.del" title="删除" fontSize="14px"
						@btnclick="AuthorityDel" :src="require('@/assets/icon/icon-del.png')">
					</Commonbtn>
				</div>
				<div style="">
					<Commonbtn backgroundColor="#F9FAFC" v-if="qx.del" title="作废" fontSize="14px"
						@btnclick="AuthorityInvalid" :src="require('@/assets/icon/icon-del3.png')">
					</Commonbtn>
				</div>
				<div style="" v-if="false">
					<Commonbtn backgroundColor="#FFF" title="驳回" fontSize="14px" @btnclick="Rejectapproval"
						:src="require('@/assets/channel/Rejectapproval.png')">
					</Commonbtn>
				</div>
				<div style="">
					<CommonbtnUpLoad v-if="qx.enabled" types="multiplePDF" backgroundColor="#F9FAFC" title="批量导入文件"
						fontSize="14px" @getFiles="SealUpload" :src="require('@/assets/channel/zhengzhao.png')">
					</CommonbtnUpLoad>
				</div>
				<div style="">
					<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" title="取消盖章" fontSize="14px"
						@btnclick="CancelSeal" :src="require('@/assets/channel/Rejectapproval.png')">
					</Commonbtn>
				</div>
				<div style="">
					<a class="Dowload" v-if="qx.add" style="text-decoration: underline;margin-top: 15px;"
						@click="DownloadTemplate">下载授权书生成模版</a>
				</div>

			</div>
			<div class="Table">
				<Commontable ref="refTableCenter" :auth="qx" @handleSelectionChange="handleSelectionChange" @Look="Look"
					@Download="Download" @PrintClick="PrintClick" @onRowClick="onRowClick" @RemarkClick="RemarkClick"
					width="1000px" colnum=511 :tableData="tableData" :headerData="headerData" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
		</div>
		<DialogFrom width="1000px" title="修改授权申请" :OKASCAN="true" :dialogVisible="dialogVisibAuthorizationsAPP"
			@cancel="cancelAuthorizationsAPP" @dialogOK="dialogOKAuthorizationsAPP">
			<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod" @AuthorizedProduct="AuthorizedProduct"
				@invClassChange="invClassChange"></FromComm>
			<div class="line">
			</div>
			<div>
				<div>
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增行"
						fontSize="14px" @btnclick="addClickRow">
					</Commonbtn>
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/del-j.png')" title="删除行"
						fontSize="14px" @btnclick="delClickRow">
					</Commonbtn>
				</div>
				<Commontable ref="refTableCenterApply" @handleSelectionChange="handleSelectionChangeEditor"
					@onRowClick="onRowClickEditor" width="1000px" colnum=522 :tableData="tableDataEditor"
					:headerData="headerDataEditor" height="100%">
				</Commontable>
			</div>
		</DialogFrom>

		<DialogFrom width="1000px" title="删除原因" :OKASCAN="true" :dialogVisible="dialogVisibdelReason"
			@cancel="canceldelReason" @dialogOK="dialogOKdelReason">
			<el-input type="textarea" placeholder="请输入删除原因" v-model="RejectReasondel">
			</el-input>
		</DialogFrom>
		<DialogFrom width="1000px" title="驳回原因" :OKASCAN="true" :dialogVisible="dialogVisibRejectReason"
			@cancel="cancelRejectReason" @dialogOK="dialogOKRejectReason">
			<el-input type="textarea" placeholder="请输入驳回原因" v-model="RejectReason">
			</el-input>
		</DialogFrom>
		<DialogFrom width="1000px" title="选择医院" :OKASCAN="true" :dialogVisible="dialogVisibAuthorizationsAddHP"
			@cancel="cancelAuthorizationsAddHP" @dialogOK="dialogOKAuthorizationsAddHP">
			<div>
				<FromComm :FromArr="FromArrHP"></FromComm>
				<div>
					<CommonBtngroup style="margin-top: -20px;margin-bottom: 10px;margin-right: 40px;" ref="btngroup"
						:qhide="false" @showclick="showclickHP" @hide="hideHP" @select="selectHP" @reset="resetHP">
					</CommonBtngroup>
				</div>
			</div>
			<div>

			</div>
			<div>
				<Commontable ref="refTableCenterHP" @handleSelectionChange="handleSelectionChangeEditorHP"
					@onRowClick="onRowClickHP" width="1000px" colnum=522 :tableData="tableDataEditorHP"
					:headerData="headerDataEditorHP" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' @handleCurrentChange="handleCurrentChangeHP"
						@handleSizeChange="handleSizeChangeHP" :total="totalHP" :pageSize="pageSizeHP"></Pagination>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="归创/通桥授权书模版" :OKASCAN="false" :dialogVisible="dialogVisibPowerattorneytemplate"
			@cancel="cancelPowerattorneytemplate" @dialogOK="dialogOKPowerattorneytemplate">
			<!-- <div v-if="IsUploadFile == 0">
        <div class="GCTQ" v-if="InvClass == '101'">
          <CertificateAuthorizationGCTQ :GCTQDATA="GCTQList" @leftClick="leftClick" @download="GCTQdownload" @Print="GCTQPrint"></CertificateAuthorizationGCTQ>
        </div>
        <div class="GCYL" v-if="InvClass == '102'">
          <CertificateAuthorizationGCYL :GCYLDATA="GCYLList" @rightClick="rightClick" @download="GCYLdownload" @Print="GCYLPrint"></CertificateAuthorizationGCYL>
        </div>
      </div> -->
			<!--  v-else-if="IsUploadFile == 1" -->
			<div>
				<div>
					<commFromVuePdf :URL="fileUrl"></commFromVuePdf>
				</div>
			</div>

		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleVerify" @cancel="cancelVerify"
			@dialogOK="dialogOKVerify" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核通过这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleInv" @cancel="cancelInv" @dialogOK="dialogOKInv"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要作废这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleCancelSeal" @cancel="cancelCancelSeal"
			@dialogOK="dialogOKCancelSeal" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要取消这条信息的盖章吗？</span>
		</Dialog>
		<DialogFrom width="750px" title="备注信息" :dialogVisible="dialogVisibleRemark" @cancel="cancelRemark"
			@dialogOK="dialogOKRemark">
			<div style="margin-left: -10px;margin-top: -10px;">
				<CommonbtnUpLoad backgroundColor="#FFF" types="UploadAll" title="文件上传" fontSize="14px"
					@getFile="UploadRemarkFiles" :src="require('@/assets/icon/daoc.png')">
				</CommonbtnUpLoad>
			</div>
			<div class="UploadData"
				v-if="RemarkInfo.lstAttachment&&RemarkInfo.lstAttachment.length||RemarkInfo.newAttachment&&RemarkInfo.newAttachment.length">
				<div class="lable">
					文件：
				</div>
				<div class="imgOrFile">
					<template v-if="RemarkInfo.lstAttachment&&RemarkInfo.lstAttachment.length">
						<div class="file" v-for="(item,index) in RemarkInfo.lstAttachment" :key="'t'+index">
							<span class="fileName">
								{{ item.FileNameOrg?item.FileNameOrg:item.FileName}}
							</span>
							<span class="Del" @click="handDelFile(index,1)">删除</span>
							<span class="See" @click="handViewFile(item)">查看</span>
						</div>
					</template>
					<template v-if="RemarkInfo.newAttachment&&RemarkInfo.newAttachment.length">
						<div class="file" v-for="(item,index) in RemarkInfo.newAttachment" :key="'f'+index">
							<span class="fileName">
								{{ item.FileNameOrg?item.FileNameOrg:item.FileName}}
							</span>
							<span class="Del" @click="handDelFile(index,2)">删除</span>
							<span class="See" @click="handViewFile(item)">查看</span>
						</div>
					</template>
				</div>
			</div>
			<div style="color: #333333;font-size: 14px;">
				备注：
			</div>
			<textarea style="border: 1px solid #E6E6E6;width: 678px;height: 180px;margin-top: 10px;padding:12px;"
				v-model="RemarkInfo.Memo"></textarea>
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../components/common-btn.vue'
	import CommonbtnUpLoad from './../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../components/common-table.vue'
	import Pagination from '../../../../../../components/pagination.vue'
	import DialogFrom from '../../../../../../components/dialog-from.vue'
	import Dialog from '../../../../../../components/dialog.vue'
	import CertificateAuthorizationGCTQ from './components/CertificateAuthorizationGCTQ'
	import CertificateAuthorizationGCYL from './components/CertificateAuthorizationGCYL'
	import commFromVuePdf from '@/components/comm-from-vuePdf.vue'
	import FromArr from './FromData/FromArr'
	import FromArrEditor from './FromData/FromArrEditor'
	import FromArrHP from './FromData/FromArrHP'
	import headerData from './headerData/headerData'
	import headerDataEditor from './headerData/headerDataEditor'
	import headerDataEditorHP from './headerData/headerDataEditorHP'
	import utils from '../../../../../../common/utils'
	import {
		BusinessAuthorityList,
		BusinessAuthorityInfo,
		BusinessAuthorityImportBusinessAuthority,
		BusinessAuthorityDownloadTemplet,
		BusinessAuthorityGeneratePdf,
		BusinessAuthorityGeneratePdfList,
		BusinessAuthorityPrintPdfList,
		BusinessAuthorityVerify,
		BusinessAuthorityDelete,
		BusinessAuthorityDisable,
		BusinessAuthorityExport,
		APPBusinessAuthorityAdd,
		BusinessAuthorityReject,
		BusinessAuthorityUpLoadAttachment,
		BusinessAuthorityUpLoadAttachments,
		BusinessAuthorityRemoveAttachment,
		GetManufacturerList,
		GetBusinessAuthorityMemo,
		UpLoadMemoAttachmentMemo,
		SetBusinessAuthorityMemo
	} from '@/api/channel'
	import {
		HospitalList,
		CustomerList,
		GetHospitalType,
		InventoryClassList,
		UserInfoByInvClass,
		Status
	} from '@/api/home'
	import {
		__esModule
	} from 'less/lib/less/default-options'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Commontable,
			Pagination,
			DialogFrom,
			CommonbtnUpLoad,
			CertificateAuthorizationGCTQ,
			CertificateAuthorizationGCYL,
			Dialog,
			commFromVuePdf
		},
		props: {},
		data() {
			return {
				RemarkInfo: {
					Memo: ''
				},
				dialogVisibleRemark: false,
				dialogVisibPowerattorneytemplate: false,
				dialogVisibleCancelSeal: false,
				dialogVisibdelReason: false,
				dialogVisibRejectReason: false,
				dialogVisiblesdrjg: false,
				dialogVisibleVerify: false,
				GCTQORGCYL: false,
				dialogVisibleDel: false,
				dialogVisibleInv: false,
				dialogVisibAuthorizationsAPP: false,
				dialogVisibAuthorizationsAddHP: false,
				fileUrl: '',
				RejectReason: '',
				RejectReasondel: '',
				InvClass: '',
				invClassRow: '',
				title: '',
				BAMID: '',
				ProviderID: '',
				CusCode: '',
				ProviderName: '',
				CusName: '',
				PageIndex: 1,
				pageSize: 10,
				total: 0,
				totalHP: 0,
				pageSizeHP: 10,
				pageIndexHP: 1,
				IsUploadFile: 0,
				tableDatadrjg: [],
				TableDataEditorDataOK: [], //医院选中数据
				EditorTabelData: [], //编辑授权申请弹窗表格选中数据
				PrintArr: [],
				GCYLList: [],
				GCTQList: [],
				DataListOK: [],
				FromArrHP: [],
				FromArr: [],
				FromArrEditor: [],
				headerData: [],
				tableData: [],
				headerDataEditor: [],
				tableDataEditor: [],
				headerDataEditorHP: [],
				tableDataEditorHP: [],
				StyleCss: {
					position: 'relative',
					left: -930,
					right: -62,
					opacityGCTQ: 1,
					opacityGQYL: 0
				},
				GCTQarr: [],
				GCYLarr: [],
				from: {
					providerName: '',
					authorityCode: '',
					invClass: '',
					startDate: '',
					endDate: '',
					createTime1: '',
					createTime2: '',
					hpName: '',
					IsUploadFile: '',
					Status: '',
					MFCode: ''
				},
				fromHP: {
					hpCode: "",
					hpName: "",
					HosType: "",
					CreateTime1: "",
					CreateTime2: "",
					authorizeStatus: "",
				},
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changeth: false, //弃审
				},
			}
		},
		computed: {
			userInfo() {
				return this.$store.state.MenusData;
			}
		},
		created() {
			this.businessAuthorityList()
			this.inventoryClassList()
			this.Status()
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.FromArrHP = JSON.parse(JSON.stringify(FromArrHP))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataEditor = JSON.parse(JSON.stringify(headerDataEditor))
			this.headerDataEditorHP = JSON.parse(JSON.stringify(headerDataEditorHP))
			if (this.userInfo && this.userInfo.IsSalesDepartment === 1) {
				this.FromArr[7].hidden = true;
			}
			this.QX()
			this.GetManufacturerList();
		},
		activated() {},
		updated() {},
		methods: {
			QX() {
				let qus = []
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.CusWebMenus.map((item, index) => {
					if (item.NodeID == 77) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 80) {
								items.Nodes.map((itemes, indexes) => {
									if (itemes.NodeID == 86) {
										qus = itemes.Buttons
									}
								})
							}
						})
					}
				})
				console.log(qus, "按钮权限");
				if (qus) {
					qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'changeth') {
							this.qx.changeth = true
						}
					})
				}
			},
			filePDFOnLoad() {
				// let iframeDocument = document.getElementById("pdf-box").contentDocument;
				// iframeDocument.body.style.background = "red"
				// console.log(iframeDocument);
			},

			// 列表
			async businessAuthorityList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				setTimeout(async () => {
					let {
						code,
						data,
						message
					} = await BusinessAuthorityList({
						providerName: this.from.providerName,
						authorityCode: this.from.authorityCode,
						invClass: this.from.invClass,
						startDate: this.from.startDate,
						endDate: this.from.endDate,
						createTime1: this.from.createTime1,
						createTime2: this.from.createTime2,
						hpName: this.from.hpName,
						Status: this.from.Status,
						IsUploadFile: this.from.IsUploadFile,
						MFCode: this.from.MFCode,
						SalesMan: this.from.SalesMan,
						InvName: this.from.InvName,
						pageSize: this.pageSize,
						pageIndex: this.PageIndex
					})
					if (code == 0) {
						this.total = data.Count
						this.tableData = data.data
					} else {
						this.$message({
							type: 'error',
							message: message
						})
					}
					loading.close();

				}, 1000)

			},
			// 授权经销商(AutoComplete)
			async HospitalList(type, query) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.FromArrEditor[1].loading = true
				let {
					code,
					message,
					data
				} = await HospitalList({
					hpName: query,
					// hosType: "经销商",
					hpCode: this.fromHP.hpCode,
					authorizeStatus: this.fromHP.authorizeStatus,
					HosType: this.fromHP.HosType,
					CreateTime1: this.fromHP.CreateTime1,
					CreateTime2: this.fromHP.CreateTime2,
					pageSize: this.pageSizeHP,
					pageIndex: this.pageIndexHP
				})

				if (code == 0) {
					if (type == "AutoCompleteList") {
						this.FromArrEditor[1].options = []
						data.data.map((item, index) => {
							let obj = {
								value: item.HPID,
								label: item.HPName,
							}
							this.FromArrEditor[1].options.push(obj)
						})
					}
					if (type == "DialogFromList") {
						this.totalHP = data.Count
						this.tableDataEditorHP = data.data
						this.dialogVisibAuthorizationsAddHP = true
					}
				} else {
					this.$message.warning(message)
				}
				this.FromArrEditor[1].loading = false
				loading.close()
			},
			// 新增
			async APPBusinessAuthorityAdd() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await APPBusinessAuthorityAdd({
					InvClass: this.FromArrEditor[0].modelvalue,
					ProviderID: this.FromArrEditor[1].modelvalue == this.ProviderName ? this.ProviderID : this
						.FromArrEditor[1].modelvalue,
					CusCode: this.FromArrEditor[2].modelvalue == this.CusName ? this.CusCode : this
						.FromArrEditor[2].modelvalue,
					StartDate: this.FromArrEditor[4].StartTime,
					EndDate: this.FromArrEditor[4].EndTime,
					Remark: this.FromArrEditor[6].modelvalue,
					NeedBossApproval: 0,
					ListInvName: this.FromArrEditor[3].modelvalue,
					lstHospitalInPuts: this.tableDataEditor
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibAuthorizationsAPP = false
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			cancelAuthorizationsAPP() {
				this.dialogVisibAuthorizationsAPP = false
			},
			dialogOKAuthorizationsAPP() {
				this.APPBusinessAuthorityAdd()
			},
			update() {
				if (this.BAMID) {
					this.businessAuthorityInfo(this.BAMID, 'updateApp')
					return
				}
				this.$message.error('请选择操作的数据！')
			},

			cancelAuthorizationsAddHP() {
				this.dialogVisibAuthorizationsAddHP = false
			},
			dialogOKAuthorizationsAddHP() {
				console.log(this.TableDataEditorDataOK, 'this.TableDataEditorDataOK');
				for (const item of this.TableDataEditorDataOK) {
					// 检查缓存中是否已经存在
					if (this.tableDataEditor.find(EDitem => EDitem.HPID == item.HPID)) {
						// 已经存在说明以前记录过，现在这个就是多余的，直接忽略
						continue;
					}
					let obj = {
						HPName: item.HPName,
						HPID: item.HPID,
						Doctor: '',
						TechnicalOffices: '',
						SurgeryCountPerYear: ''
					}
					this.tableDataEditor.push(obj)
				}
				this.dialogVisibAuthorizationsAddHP = false
			},
			// AutoComplete事件
			remoteMethod(val, par) {
				console.log(val, par, 'methodName');
				if (val.parsign == 'AuthorizedDealer') {
					this.HospitalList('AutoCompleteList', val.qurey)
				} else if (val.parsign == 'OrderingDealer') {
					this.CustomerList(val.qurey)
				}
			},
			// 授权申请弹窗，公司下拉的change事件
			invClassChange(e) {
				this.UserInfoByInvClass(e.FromArr[0].modelvalue)
			},
			AuthorizedProduct(e) {
				console.log('eeeeeeeeee');
				// 
			},
			addClickRow() {
				this.HospitalList('DialogFromList')
				this.GetHospitalType()
			},
			delClickRow() {
				// this.EditorTabelData //准备删除操作数据
				// tableDataEditor
				this.EditorTabelData.map((item, index) => {
					this.tableDataEditor.map((items, indexs) => {
						console.log(item.HPID == items.HPID);
						if (item.HPID == items.HPID) {
							this.tableDataEditor.splice(indexs, 1)
						}
					})
				})
			},
			handleSelectionChangeEditor(val) {
				this.EditorTabelData = val
			},
			onRowClickEditor() {

			},
			// 生产厂商
			async GetManufacturerList() {
				let {
					code,
					message,
					data
				} = await GetManufacturerList({})
				if (code == 0) {
					this.FromArr[8].options = []
					data.data.map((item, index) => {
						let obj = {
							value: item.MFName,
							key: item.MFCode,
						}
						this.FromArr[8].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},
			// 订货经销商(AutoComplete)
			async CustomerList(query) {
				this.FromArrEditor[2].loading = true
				let {
					code,
					message,
					data
				} = await CustomerList({
					CusName: query,
				})
				if (code == 0) {
					this.FromArrEditor[2].options = []
					data.data.map((item, index) => {
						let obj = {
							value: item.CusCode,
							label: item.CusName,
						}
						this.FromArrEditor[2].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
				this.FromArrEditor[2].loading = false
			},
			// 授权产品下拉数据
			async UserInfoByInvClass(InvClass) {
				let {
					code,
					message,
					data
				} = await UserInfoByInvClass({
					InvClass: InvClass
				})
				if (code == 0) {
					this.FromArrEditor[3].options = []
					data.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArrEditor[3].options.push(obj)
					})
				}
			},
			// 客服分类
			async GetHospitalType() {
				let {
					code,
					data
				} = await GetHospitalType({

				})
				if (code == 0) {
					this.FromArrHP[3].options = []
					data.map((item, index) => {
						let obj = {
							key: index,
							value: item.Name
						}
						this.FromArrHP[3].options.push(obj)
					})
				}
			},
			handleSelectionChangeEditorHP(val) {
				this.TableDataEditorDataOK = val
			},
			reset() {
				this.FromArr.map((item, index) => {
					if (index == 6) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = ''
				})
			},
			showclickHP() {

			},
			hideHP() {

			},
			selectHP() {
				this.pageIndexHP = 1
				this.fromHP.hpCode = this.FromArrHP[0].modelvalue
				this.fromHP.hpName = this.FromArrHP[1].modelvalue
				this.fromHP.authorizeStatus = this.FromArrHP[2].modelvalue
				this.fromHP.HosType = this.FromArrHP[3].modelvalue
				this.fromHP.CreateTime1 = this.FromArrHP[4].StartTime
				this.fromHP.CreateTime2 = this.FromArrHP[4].EndTime
				this.HospitalList("DialogFromList", this.fromHP.hpName)
			},
			resetHP() {
				this.FromArrHP.map((item, index) => {
					if (index == 4) {
						item.StartTime = ''
						item.EndTime = ''
					}
					if (index != 3) {
						item.modelvalue = ''
					}
				})
			},
			onRowClickHP(val) {

			},
			handleCurrentChangeHP(PageIndex) {
				this.pageIndexHP = PageIndex
				this.HospitalList('DialogFromList')
			},
			handleSizeChangeHP(PageSize) {
				this.pageSizeHP = PageSize
				this.HospitalList('DialogFromList')
			},
			// 导出
			async BusinessAuthorityExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await BusinessAuthorityExport({
					providerName: this.from.providerName,
					authorityCode: this.from.authorityCode,
					invClass: this.from.invClass,
					startDate: this.from.startDate,
					endDate: this.from.endDate,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					hpName: this.from.hpName,
					Status: this.from.Status,
					IsUploadFile: this.from.IsUploadFile,
					InvName: this.from.InvName,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `授权书导出${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出事件调用接口
			ExportAuthoriy() {
				this.BusinessAuthorityExport()
			},
			// 查看
			async businessAuthorityInfo(row, type) {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await BusinessAuthorityInfo({
					BAMID: row.BAMID,
				})
				if (code == 0) {
					if (type == 'updateApp') {
						this.FromArrEditor[0].modelvalue = data.data.InvClass
						this.FromArrEditor[1].modelvalue = data.data.ProviderName
						this.FromArrEditor[2].modelvalue = data.data.CusName
						this.FromArrEditor[3].modelvalue = data.data.ListInvName
						this.FromArrEditor[4].StartTime = data.data.StartDate
						this.FromArrEditor[4].EndTime = data.data.EndDate
						this.FromArrEditor[5].checked = false // data.data.NeedBossApproval == 1 ? true : false
						this.FromArrEditor[6].modelvalue = data.data.Remark
						this.tableDataEditor = data.data.lstHospitalOutPuts
						this.UserInfoByInvClass(data.InvClass)
						this.ProviderID = data.data.ProviderID
						this.CusCode = data.data.CusCode
						this.ProviderName = data.data.ProviderName
						this.CusName = data.data.CusName
						this.dialogVisibAuthorizationsAPP = true
					}
					if (type == 'See') {
						this.InvClass = data.data.MFCode
						this.IsUploadFile = data.data.IsUploadFile
						if (data.data.IsUploadFile == 1 || data.data.IsUploadFile == 0) {
							this.BusinessAuthorityGeneratePdf(row, 'See')
						}
						// if (data.data.IsUploadFile == 0) {
						//   // if (this.InvClass == '101') {
						//   //   this.GCTQList = data.data
						//   // }
						//   // if (this.InvClass == '102') {
						//   //   this.GCYLList = data.data
						//   // }
						//   if (data.data.MFCode == '101') {
						//     this.GCTQList = data.data
						//   }
						//   if (data.data.MFCode == '102') {
						//     this.GCYLList = data.data
						//   }
						// }
						this.dialogVisibPowerattorneytemplate = true
					}
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
				loading.close();
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.FromArr[2].options = []
					this.FromArrEditor[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArrEditor[0].options.push(obj)
						this.FromArr[2].options.push(obj)
					})
				}
			},

			// 状态下拉
			async Status() {
				let {
					code,
					data,
					message
				} = await Status({})
				if (code == 0) {
					this.FromArr[6].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[6].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},
			// 导入授权书
			async businessAuthorityImportBusinessAuthority(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await BusinessAuthorityImportBusinessAuthority(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.businessAuthorityList()
					} else if (res.code == 1) {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = '导入结果'
					} else {

						this.$message({
							type: 'error',
							message: res.message
						})
					}
					loading.close();
				}
			},
			// 盖章证照上传
			async BusinessAuthorityUpLoadAttachment(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await BusinessAuthorityUpLoadAttachment(formData, this.BAMID)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.businessAuthorityList()
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = '导入结果'
						this.$message({
							type: 'error',
							message: res.message
						})
					}
					loading.close();
				}
			},
			// 批量导入
			async BusinessAuthorityUpLoadAttachments(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					for (var i = 0; i < file.length; i++) {
						formData.append("files", file[i]);
					}
					let res = await BusinessAuthorityUpLoadAttachments(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.businessAuthorityList()
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = '导入结果'
						this.$message({
							type: 'error',
							message: res.message
						})
					}
					loading.close();
				}
			},

			//   批量生成
			BatchGeneration(file) {
				this.businessAuthorityImportBusinessAuthority(file)
			},
			// 取消盖章接口
			async BusinessAuthorityRemoveAttachment() {
				let {
					code,
					message,
					data
				} = await BusinessAuthorityRemoveAttachment({
					BAMID: this.BAMID
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleCancelSeal = false
					this.businessAuthorityList()
				} else {
					this.$message.warning(message)
				}
			},
			// 取消盖章
			CancelSeal() {
				if (this.BAMID) {
					this.dialogVisibleCancelSeal = true
					return
				}
				this.$message.error('请选择操作的数据！')
			},
			// 盖章证照上传
			SealUpload(file) {
				this.BusinessAuthorityUpLoadAttachments(file)
				console.log(file);
				// if (this.BAMID) {
				//   this.BusinessAuthorityUpLoadAttachments(file)
				//   return
				// }
				// this.$message.error('请选择操作的数据！')
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},

			// 导出
			Export() {

			},

			// 批量打印
			PrintAll() {
				let BAMIDS = []
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID)
				})
				if (BAMIDS.length <= 0) {
					this.$message.warning('请选择需要打印的数据')
					return
				}
				this.BusinessAuthorityGeneratePdfList(BAMIDS, 'Print')
			},
			//批量下载
			DownloadAll() {
				let BAMIDS = []
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID)
				})
				if (BAMIDS.length <= 0) {
					this.$message.warning('请选择需要下载的数据')
					return
				}
				this.BusinessAuthorityGeneratePdfList(BAMIDS, 'downloadAll')
			},
			// 下载模板
			async businessAuthorityDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await BusinessAuthorityDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}

			},
			// 下载模板
			DownloadTemplate() {
				this.businessAuthorityDownloadTemplet()
			},
			// 单行查看
			Look(row) {
				console.log(row, '单行查看');
				this.businessAuthorityInfo(row, 'See')
			},
			// PDF下载/打印（多行）
			async BusinessAuthorityGeneratePdfList(bamiDs, type) {

				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = null;
				if (type == 'Print') {
					res = await BusinessAuthorityPrintPdfList({
						bamiDs: bamiDs
					})
				} else {
					res = await BusinessAuthorityGeneratePdfList({
						bamiDs: bamiDs
					})
				}
				if (res) {
					if (type == 'download') {
						let date = new Date()
						let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
						utils.downloadFile(res, `pdf${str}`, "pdf")
					}
					if (type == 'downloadAll') {
						let date = new Date()
						let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
						utils.downloadFile(res, `授权书${str}`, "rar", "application/zip")
					}
					if (type == 'Print') {
						utils.downloadFilePdfStream(res, "application/pdf");
					}

				} else {
					// 返回json
					if (type == 'download') {
						this.$message.warning(`导出失败${res.message}`);
					}
					if (type == 'Print') {
						this.$message.warning(`打印失败${res.message}`);
					}
				}
				loading.close();
			},
			// PDF下载/打印（单行）
			async BusinessAuthorityGeneratePdf(parameter, type) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let res = await BusinessAuthorityGeneratePdf({
					bamid: parameter.BAMID
				})
				if (res) {
					if (type == 'download') {
						let date = new Date();
						// console.log(parameter.IsUploadFile, 'ss');
						// let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`;
						utils.downloadFile(res, `${parameter.ProviderName}-${parameter.AuthorityCode}`, "pdf");


						// if (parameter.IsUploadFile == 1) {
						//   utils.downloadFile(res, `${parameter.ProviderName}-${parameter.CreateTime.substring(0, 10)}`, "pdf");
						// } else if (parameter.IsUploadFile == 0) {
						//   utils.downloadFile(res, `${parameter.ProviderName}-${parameter.CreateTime.substring(0, 10)}`, "pdf");
						// }

					}
					if (type == 'Print') {
						utils.downloadFilePdfStream(res, "application/pdf");
						// if (parameter.IsUploadFile == 0) {
						//   utils.downloadFilePdfStream(res , "application/pdf");
						// } else if (parameter.IsUploadFile == 1) {
						//   utils.downloadFilePdfStream(res , "application/pdf");
						// }
					}
					if (type == 'See') {
						this.fileUrl = utils.getObjectURL(res)
						console.log(this.fileUrl);
					}
				} else {
					if (type == 'download') {
						this.$message.warning(`导出失败`);
					}
					if (type == 'Print') {
						this.$message.warning(`打印失败`);
					}
				}
				loading.close();
			},
			// 单行下载
			Download(row) {
				console.log(row, '单行下载');
				this.BusinessAuthorityGeneratePdf(row, 'download');
			},

			// 单行打印
			PrintClick(row) {
				console.log(row);
				this.BusinessAuthorityGeneratePdf(row, 'Print');
			},
			// 审核
			async BusinessAuthorityVerify(BAMIDS) {
				let {
					code,
					data,
					message
				} = await BusinessAuthorityVerify({
					bamiDs: BAMIDS
				})
				if (code == 0) {
					this.$message.success(message);
					this.businessAuthorityList();
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
				} else {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = '审核结果';
					this.$message.warning(message);
				}
				this.dialogVisibleVerify = false;
			},
			// 审核
			AuthorityVerify() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请选择需要审核的数据（多选）');
					return
				}
				this.dialogVisibleVerify = true;
			},
			cancelVerify() {
				this.dialogVisibleVerify = false;
			},
			dialogOKVerify() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})
				this.BusinessAuthorityVerify(BAMIDS)
			},
			// 删除
			async BusinessAuthorityDelete(BAMIDS) {
				let {
					code,
					data,
					message
				} = await BusinessAuthorityDelete({
					bamiDs: BAMIDS,
					RejectReason: this.RejectReasondel
				})
				if (code == 0) {
					this.$message.success(message);
					this.businessAuthorityList();
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
					this.dialogVisibdelReason = false
				} else {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = '删除结果';
					this.$message.warning(message);
				}
				this.dialogVisibleDel = false;
			},
			// 作废
			async BusinessAuthorityDisable(BAMIDS) {
				let {
					code,
					data,
					message
				} = await BusinessAuthorityDisable({
					bamiDs: BAMIDS,
					RejectReason: this.RejectReasondel
				})
				if (code == 0) {
					this.$message.success(message);
					this.businessAuthorityList();
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
					this.dialogVisibdelReason = false
				} else {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = '作废结果';
					this.$message.warning(message);
				}
				this.dialogVisibleInv = false;
			},
			// 驳回
			async BusinessAuthorityReject(BAMIDS) {
				if (!this.RejectReason) {
					this.$message.warning('请填写驳回原因')
					return
				}
				let {
					code,
					data,
					message
				} = await BusinessAuthorityReject({
					bamiDs: BAMIDS,
					RejectReason: this.RejectReason
				})
				if (code == 0) {
					this.$message.success(message);
					this.businessAuthorityList();
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
					this.dialogVisibRejectReason = false
				} else {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = data;
					this.title = '驳回结果';
					this.$message.warning(message);
				}
			},
			Rejectapproval() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请选择需要驳回的数据（多选）');
					return
				}
				this.dialogVisibRejectReason = true
			},
			AuthorityDel() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请选择需要删除的数据（多选）');
					return
				}
				this.dialogVisibleDel = true
				// console.log(this.DataListOK.some(item => item.NeedReasonWhenDelete == 1));
				// if (this.DataListOK.some(item => item.NeedReasonWhenDelete == 1)) {
				//   this.dialogVisibdelReason = true
				// } else {
				//   this.dialogVisibleDel = true
				// }
			},
			AuthorityInvalid() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请选择需要作废的数据（多选）');
					return
				}
				this.dialogVisibleInv = true
			},
			cancelDel() {
				this.dialogVisibleDel = false
			},
			cancelInv() {
				this.dialogVisibleInv = false
			},
			dialogOKDel() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})
				this.BusinessAuthorityDelete(BAMIDS)
			},
			dialogOKInv() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})
				this.BusinessAuthorityDisable(BAMIDS)
			},
			cancelCancelSeal() {
				this.dialogVisibleCancelSeal = false
			},
			dialogOKCancelSeal() {
				this.BusinessAuthorityRemoveAttachment()
			},
			handleDrop(e) {
				switch (e) {
					case 'a':
						this.PrintAll();
						break;
					case 'b':
						this.DownloadAll();
						break;
				}
			},
			rightClick() {
				this.$nextTick(() => {
					this.StyleCss.right = -62;
					this.StyleCss.left = -1000;
					this.StyleCss.opacityGCTQ = 1;
					this.StyleCss.opacityGQYL = 0;
				})
				this.GCTQORGCYL = true;
			},
			leftClick() {
				this.$nextTick(() => {
					this.StyleCss.left = 0;
					this.StyleCss.right = -1000;
					this.StyleCss.opacityGCTQ = 0;
					this.StyleCss.opacityGQYL = 1;
				})
				this.GCTQORGCYL = false;
			},
			// 归创通桥下载
			GCTQdownload(GCTQDATA) {
				this.Download(GCTQDATA)
			},
			// 归创通桥打印
			GCTQPrint(GCTQDATA) {
				this.PrintClick(GCTQDATA)
			},
			//归创医疗下载
			GCYLdownload(GCYLDATA) {
				this.Download(GCYLDATA)
			},
			// 归创医疗打印
			GCYLPrint(GCYLDATA) {
				this.PrintClick(GCYLDATA)
			},
			showclick() {

			},
			hide() {

			},
			select() {
				this.pageIndex = 1
				this.from.providerName = this.FromArr[0].modelvalue
				this.from.authorityCode = this.FromArr[1].modelvalue
				this.from.invClass = this.FromArr[2].modelvalue ? this.FromArr[2].modelvalue.join(',') : ''
				this.from.startDate = this.FromArr[3].StartTime
				this.from.endDate = this.FromArr[3].EndTime
				this.from.createTime1 = this.FromArr[4].StartTime
				this.from.createTime2 = this.FromArr[4].EndTime
				this.from.hpName = this.FromArr[5].modelvalue
				this.from.Status = this.FromArr[6].modelvalue
				this.from.IsUploadFile = this.FromArr[7].modelvalue
				this.from.MFCode = this.FromArr[8].modelvalue
				this.from.SalesMan = this.FromArr[9].modelvalue
				this.from.InvName = this.FromArr[10].modelvalue
				this.businessAuthorityList()
			},
			reset() {
				this.FromArr.map((item, index) => {
					if (index == 3 || index == 4) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = ''
				})
			},
			handleSelectionChange(val) {
				console.log(val);
				this.DataListOK = val
			},
			onRowClick(val) {
				this.BAMID = val.BAMID
			},
			handleCurrentChange(PageIndex) {
				this.PageIndex = PageIndex
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
				this.businessAuthorityList()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
				this.businessAuthorityList()
			},
			cancelPowerattorneytemplate() {
				this.dialogVisibPowerattorneytemplate = false
			},
			dialogOKPowerattorneytemplate() {
				this.dialogVisibPowerattorneytemplate = false
			},
			cancelRejectReason() {
				this.dialogVisibRejectReason = false
			},
			dialogOKRejectReason() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})
				this.BusinessAuthorityReject(BAMIDS)

			},
			canceldelReason() {
				this.dialogVisibdelReason = false
			},
			dialogOKdelReason() {
				let BAMIDS = [];
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID);
				})
				console.log(this.RejectReason, 'this.RejectReason');
				this.BusinessAuthorityDelete(BAMIDS)

			},
			// 单行备注
			async RemarkClick(row) {
				let {
					code,
					data,
					message
				} = await GetBusinessAuthorityMemo({
					BAMID: row.BAMID
				})
				if (code == 0) {
					this.RemarkInfo = data;
					this.dialogVisibleRemark = true;
				} else {
					this.$message.warning(message);
				}
			},
			//取消
			cancelRemark() {
				this.dialogVisibleRemark = false;
				setTimeout(() => {
					this.RemarkInfo = {
						Memo: ''
					};
				}, 200)
			},
			//提交
			async dialogOKRemark() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let files = [];

				if (this.RemarkInfo.lstAttachment && this.RemarkInfo.lstAttachment.length) {
					let names = this.RemarkInfo.lstAttachment.map(it => it.FileName);
					names.map(it => {
						files.push(it);
					})
				}
				if (this.RemarkInfo.newAttachment && this.RemarkInfo.newAttachment.length) {
					let names = this.RemarkInfo.newAttachment.map(it => it.FileName);
					names.map(it => {
						files.push(it);
					})
				}
				let {
					code,
					data,
					message
				} = await SetBusinessAuthorityMemo({
					BAMID: this.RemarkInfo.BAMID,
					Memo: this.RemarkInfo.Memo,
					lstAttachmentNames: files
				});
				loading.close();
				if (code == 0) {
					this.$message.success('提交成功');
					this.cancelRemark();
				} else {
					this.$message.warning(message);
				}
			},
			//上传
			async UploadRemarkFiles(e) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formData = new FormData();
				formData.append('files', e);
				let {
					code,
					data,
					message
				} = await UpLoadMemoAttachmentMemo(formData);
				loading.close();
				if (code == 0) {
					if (this.RemarkInfo.newAttachment && this.RemarkInfo.newAttachment.length) {
						this.RemarkInfo.newAttachment.push(data[0]);
					} else {
						this.$set(this.RemarkInfo, 'newAttachment', []);
						this.RemarkInfo.newAttachment.push(data[0]);
					}
				} else {
					this.$message.warning(message);
				}
			},
			//预览文件
			handViewFile(e) {
				window.open(e.FileUrl);
			},
			//删除文件
			handDelFile(i, t) {
				if (t === 1) {
					this.RemarkInfo.lstAttachment.splice(i, 1);
				}
				if (t === 2) {
					this.RemarkInfo.newAttachment.splice(i, 1);
				}
			}
		},
		watch: {
			dialogVisibAuthorizationsAPP: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.FromArrEditor.map((item, index) => {
							if (index == 4) {
								item.StartTime = ''
								item.EndTime = ''
							}
							if (index == 5) {
								item.checked = false
							}
							item.modelvalue = ''
						})
						this.FromArrEditor[3].options = []
						this.tableDataEditor = []
						this.$refs.refTableCenterApply.$refs.fileTableSelect.clearSelection()
					}
				}
			},
			dialogVisibAuthorizationsAddHP: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.$refs.refTableCenterHP.$refs.fileTableSelect.clearSelection()
					}
					if (newVal) {
						if (this.tableDataEditorHP) {
							// 匹配选中行勾选
							setTimeout(() => {
								this.tableDataEditorHP.map((item, index) => {
									this.tableDataEditor.map((items, indexs) => {
										//  console.log(this.tableDataEditor, 'this.tableDataEditor');
										//   console.log(this.tableDataEditorHP, 'this.tableDataEditorHP');
										console.log(item.HPID == items.HPID,
											'this.tableDataEditorHP');
										if (item.HPID == items.HPID) {
											console.log(this.$refs, 'this.$refs.refTableCenterHP');
											this.$refs.refTableCenterHP.$refs.fileTableSelect
												.toggleRowSelection(item, true);
										}
									})
								})
							}, 100)
						}
					}
				}
			},
			dialogVisibPowerattorneytemplate: {
				handler(newVal, OldVal) {
					if (!newVal) {
						// console.log(this.$refs.refTableCenter.$refs.fileTable.clearSelection());
					}
				}
			},
			dialogVisibRejectReason: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.RejectReason = ''
					}
				}
			},

		},
	}
</script>
<style scoped lang='less'>
	.GCTQ {
		// border: 1px solid red;
		transition: all 0.5s;
	}

	.GCYL {
		//  border: 1px solid rgb(23, 120, 211);
		transition: all 0.5s;
	}

	.Authority {
		width: 100%;
		height: 100%;

		.TopSearch {
			margin: 1px 10px;
			width: 938px;
			height: 283px;
			// outline: 1px solid red;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.BottomTable {
			margin: 32px 10px;
			padding: 10px;
			width: 920px;
			// height: 518px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}
	}


	.drop-down-link {
		margin: 10px;
		width: 100%;
		height: 32px;
		line-height: 32px;
		color: rgb(0, 0, 0);
		font-size: 14px;
		background-color: rgb(249, 250, 252);
		border: 1px solid #e6e6e6;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	/deep/.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: rgb(255 235 235);
		color: #606266;
	}

	.UploadData {
		display: inline-block;
		width: 100%;

		.lable {
			width: 130px;
			margin-top: 20px;
			font-weight: 500;
			font-size: 14px;
			color: rgb(51, 51, 51);
			height: 20px;
			display: inline-block;
		}

		.imgOrFile {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.file {
				line-height: 32px;
				border-radius: 2px;
				border: 1px solid rgb(230, 230, 230);
				display: inline-block;
				position: relative;
				//width: 300px;
				height: 32px;
				color: rgb(0, 0, 0);
				font-size: 12px;
				background-color: rgb(250, 251, 252);
				margin: 10px 7px 10px 0px;
				flex: 1;
				min-width: 344px;
				max-width: 344px;

				.fileName {
					//width: 350px;
					//display: inline-block;
					font-size: 14px;
					margin-left: 20px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.Del {
					display: inline-block;
					font-size: 14px;
					float: right;
					margin-right: 10px;
					color: rgb(231, 29, 67);
					cursor: pointer;
				}

				.See {
					//display: inline-block;
					font-size: 14px;
					float: right;
					margin-right: 10px;
					color: rgb(231, 29, 67);
					cursor: pointer;
				}
			}
		}
	}
</style>